import type { ModuleId } from '../engine/gameDef';
import type { RuleModule } from '../engine/registry';
import { turnFlowModule } from './turnFlow';
import { setupDraftModule } from './setupDraft';
import { harvestModule } from './harvest';
import { banditModule } from './bandit';
import { buildingModule } from './building';
import { supplyTradeModule } from './supplyTrade';
import { playerTradeModule } from './playerTrade';
import { advanceCardsModule } from './advanceCards';
import { awardsModule } from './awards';
import { victoryModule } from './victory';
import { pairedTurnsModule } from './pairedTurns';
import { specialBuildingPhaseModule } from './specialBuildingPhase';

// The static module registry (brief §6.2: v0 registry = static imports). Extension packages
// post-v0 register here through the same map.

// the one victory helper servers need outside the engine (finalize rows, plan §14.2), and
// its public-only sibling — the number the Friendly Bandit judges by (T-ENG-079)
export { trueVp, publicVp } from './victory';

// the two override reads the S2 host knobs thread into (map override ⇒ room knob ⇒
// default, T-NET-032 pins the chain against THESE, never a re-implementation)
export { victoryTarget } from './victory';
export { discardThreshold } from './bandit';

// the §8.2 maritime rates, so the client can SHOW a seat its own rates from a redacted
// view instead of re-deriving the rule (H7-S1, T-UI-026)
export { availableRates, ratesFromVertices } from './supplyTrade';
// H11: the client shows what a seat has LEFT to build — the same pool the validator reads.
export { poolRemaining } from './building';
// D192: the client shows the viewer their own route length on the shelf, and it must be the
// number the award is decided by — so the engine's own function is what it calls.
export { routeLength } from './awards';
// D253: the log panel's production score — the harvest's own tables, so the number a player
// reads can never disagree with what the dice will pay.
export { hexProduction, productionScores } from './harvest';
// D252: "has anyone still not answered?" — the bot proposer's hold asks the engine, both hosts.
export { hasUnansweredOffer } from './playerTrade';

export const BASE_MODULE_REGISTRY: ReadonlyMap<ModuleId, RuleModule> = new Map<ModuleId, RuleModule>(
  [
    turnFlowModule,
    setupDraftModule,
    harvestModule,
    banditModule,
    buildingModule,
    supplyTradeModule,
    playerTradeModule,
    advanceCardsModule,
    awardsModule,
    victoryModule,
    pairedTurnsModule,
    specialBuildingPhaseModule,
  ].map((m) => [m.id, m]),
);
